import React, { useContext, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { createEstructuraLogsFServ, estructura_producto, estructuraLogsFServ } from "../../utils/estructuras";

// Alertas
import Swal from 'sweetalert2'
import SelectControl from "../SelecControl/SelectControl";

import {addToDate, getDifferenceInDays} from '../../utils/funciones'

const ModalFormProcedimiento = ({activo, usuario, index, minimizar, actualizarFServ, procsFiltrados, guardarRequerimientoDirecto}) => {

    const [procSelected,setProcSelected] = useState({});
    const navigate = useNavigate()

    const handleChange = (e,prop) =>{
        setProcSelected({...procSelected,[prop]:e})
    } 

    //Crear Procedimiento Programado junto a su OT (mismo request, con rollback) y redirigir a addReq para editarla.
    const handleSaveProcedimiento = async() =>{
        if(Object.keys(procSelected).length > 0){
            let newFec = new Date();
            let procFiltrado = procsFiltrados.find(p => p.codProc == procSelected.proc.value);
            
            try {
                console.log("Al modelar procedimiento directo, si es de system, se tomara en cuenta la unidad medida default del activo");
                let procModelado = {
                    codActivo: activo.codActivo,
                    codProc: procSelected.proc.value,
                    
                    // uniMed: procFiltrado.uniMed.value,
                    uniMed: (procFiltrado.tenantId == 'SYSTEM') ? activo.DEFAULTUNIMED.value : procFiltrado.uniMed.value, //Petición Leo.
                    
                    owner:procFiltrado.owner,
                    valorLecturaCompletado: 0,
                    fechaVencimiento: addToDate(new Date(),365,'day','add').toISOString().substring(0,16),
                    fechaCompletado: '',
                    CodForOT:"",
                    NroForOT:'0',
                    tipoAlerta:'PorVENC',
                    state:'PEND',
                    originado: "DIRECTO",
                    fecMod: newFec,
                    fecAlt: newFec,
                    activoID: activo._id,
                    procedimientoID: procSelected.proc.id
                }
                let ordenTrabajo = {
                    title:`Orden de Trabajo s/${procModelado.codProc} - ${activo.name}`, 
                    observ:`Orden de Trabajo sobre ${procModelado.codProc} (${procSelected.proc.label}) asociado al activo ${activo.codActivo} (${activo.name})`, 
                    tareas: procSelected.proc.tareas.slice(), 
                    checklists: procSelected.proc.checklists.slice(), //Agregado recientemente, ver como se comporta.
                    codFor: 'ODT',
                    imputaciones:[],
                    activo:{id: activo._id, label: activo.name, value:activo.codActivo}
                };

                const resp = await guardarRequerimientoDirecto(ordenTrabajo, procSelected.proc.productos, usuario, procModelado, activo);

                if(!resp.status) throw new Error(resp.msg);

                const tDoc = resp.data;
                Swal.fire({
                    title: `Procedimiento programado con Éxito!`,
                    icon: 'success',
                    text: `Se programo el procedimiento ${procModelado.codProc} y fue asociado al activo ${activo.name}`,
                    showConfirmButton: true,
                    allowEnterKey: true
                });

                if(procFiltrado.disableActivo && activo.actStatus == 'DISPO') setActivoOutOfService();
                minimizar();
                navigate('/addReq',{state:{ordenTrabajoToHandle:{...tDoc, productos:tDoc.products, nameActivo: activo.name,activo:{id:tDoc.activoID, value:procModelado.codActivo, label:activo.name}},mode:'Edit'}});
            } catch (error) {
                Swal.fire({
                    title: `Algo no funciono segun lo esperado!`,
                    icon: 'error',
                    text: `${error.message}`,//${resp.tDocNroFor}
                    showConfirmButton: true,
                    allowEnterKey: true
                });
            }
        }
    }
    
    const setActivoOutOfService = async () => {
        const logToUpload = {...createEstructuraLogsFServ(), evento: 'FSERV', activoID:activo._id, comUserID:usuario._id, userName:usuario.userName}
        await actualizarFServ(activo._id, activo.actStatus, logToUpload);
    }

    return <div className="modalFormDiv modalFormProcedimientoDiv">
        <button className="minimizarBtn" onClick={minimizar}>X</button>
        <div className="headerModalForm">Elegir Procedimiento</div>
        <div className="bodyModalForm">
            <h6>Seleccione un procedimiento a trabajar</h6>
            <SelectControl placeholder={"Seleccione una procedimiento..."} modo='Nuevo' idSelect={"procedimientoXactivo"} handleChengeSelect={handleChange} 
            optionsSelect={procsFiltrados.map(p => {return {label:p.name, value:p.codProc, tareas:p.tareas, productos:p.productos, id:p._id, checklists:p.checklists}})} 
            valueSeleccionada={procSelected.proc} tipo={'modalProcedimientoXActivo'} selectSelect={handleChange} index={index} setNuevoEditado={'Ninguno'}propToChange="procedimiento"/>
            <div className="buttonsModalDiv">
                <button className={`modalFormBtn ${Object.keys(procSelected).length > 0 ? '' : 'disabled'}`} id="saveModalBtn" onClick={()=>handleSaveProcedimiento()}>Guardar</button>    
                <button className="modalFormBtn" id="cancelBtn" onClick={minimizar}>Cancelar</button>    
            </div>
        </div>
    </div>

}

export default ModalFormProcedimiento;